import { BaseUserEndpoints } from './base';
import {
  BodyPostOrganizations,
  ResGetOrganizations,
  ResGetUser,
  ResPostUsersImpersonate,
  ResPutInvitationsJoin
} from '../types/api-types';

export interface UserMeRequestOptions {
  notThrowWithInvalidResponses?: boolean;
}

export class Users extends BaseUserEndpoints {
  async identity(authorization: string, userId: string) {
    return await this.requestWithStatus(
      'POST',
      '/identity',
      { user: userId },
      { authHeader: `Basic ${authorization}` }
    );
  }

  /**
   * Primary endpoint for returning the current authenticated user
   */
  async me(options?: UserMeRequestOptions) {
    return await this.requestWithStatus<ResGetUser>(
      'GET',
      `${this.settings.requestsToUnion ? '/api' : ''}${this.settings.adminAuth ? '/integrations' : ''}/user`,
      undefined,
      options
    );
  }

  /**
   * Primary endpoint for returning the organizations to which an authenticated user belongs
   */
  async organizations() {
    return await this.requestWithStatus<ResGetOrganizations>(
      'GET',
      `${this.settings.adminAuth ? '/integrations' : ''}/organizations`
    );
  }

  async organizationAdd(body: BodyPostOrganizations) {
    return await this.requestWithStatus('POST', '/organizations', body);
  }

  async organizationJoin(join: string) {
    return await this.requestWithStatus<ResPutInvitationsJoin>(
      'PUT',
      `/invitations/join/${encodeURIComponent(join)}`,
      {}
    );
  }
  async getUnionToken(refreshToken: string) {
    const response = await this.requestWithStatus<{
      cookies: Record<string, string>;
    }>(
      'POST',
      '/auth/token',
      `refresh_token=${encodeURIComponent(refreshToken)}`,
      {
        contentType: 'application/x-www-form-urlencoded',
        getCookiesToSet: true,
        requestsToUnion: true,
        unionToken: ''
      }
    );

    return response?.result?.cookies.union_auth;
  }

  async impersonate(body: { email: string }) {
    // Do not encodeURIComponent the email as its needed as-is per API routing
    return await this.requestWithStatus<ResPostUsersImpersonate>(
      'POST',
      `/users/${encodeURIComponent(body.email)}/impersonate`,
      {}
    );
  }
}
